// eslint-disable-next-line react/jsx-pascal-case

/* eslint-disable react/jsx-pascal-case */
import * as React from 'react'

import { Field, FieldProps } from 'formik'

import $Input, { InputProps } from '../components/Input'
import Error from './FormItemError'

export interface FormikFieldProps {
  name: string
  validate?: (value: any) => undefined | string | Promise<any>
  fast?: boolean
  label?: any
  labelCustomStyle?: string
  inputCustomStyle?: string
  hint?: any
  showRequiredSign?: boolean
  affix?: JSX.Element
  helperText?: string
}
export type FormikInputProps = FormikFieldProps & InputProps
/**
 * @deprecated The method should not be used. Please use InputV2 instead.
 */
const Input = React.forwardRef(
  (
    {
      name,
      validate,
      fast,
      label,
      onChange: $onChange,
      onBlur: $onBlur,
      optional,
      affix,
      showRequiredSign,
      labelCustomStyle,
      inputCustomStyle,
      helperText,
      ...restProps
    }: FormikInputProps,
    ref: React.Ref<typeof $Input>,
  ) => (
    <Field name={name} validate={validate} fast={fast}>
      {({ field: { value, onChange, onBlur }, meta: { error, touched } }: FieldProps) => (
        <div className="mb-8">
          <label htmlFor={restProps.id} className={labelCustomStyle ? labelCustomStyle : ''}>
            {showRequiredSign && <span className={'color-red-6 mr-4'}>*</span>}
            {label}
            {optional && <span className={'field-optional'}> (optional)</span>}
            {affix && affix}
          </label>
          <$Input
            ref={ref}
            className={inputCustomStyle}
            name={name}
            value={value}
            prefix={restProps.prefix}
            onChange={(event) => {
              onChange(event)
              $onChange && $onChange(event)
            }}
            onBlur={(event) => {
              onBlur(event)
              $onBlur && $onBlur(event)
            }}
            {...restProps}
          />
          {error && touched && <Error children={error} />}
          {helperText && <span className={'h6 mt-4 color-gray-7'}>{helperText}</span>}
        </div>
      )}
    </Field>
  ),
)
export { Input }
export default Input
